import React, { CSSProperties } from "react";
import "./Skeleton.css";

type CSSDimension = string | number;
type SkeletonTone = "theme" | "soft" | "neutral" | "alt" | "contrast";

export type SkeletonProps = {
  width?: CSSDimension;
  height?: CSSDimension;
  borderRadius?: CSSDimension;
  inline?: boolean;
  tone?: SkeletonTone;
  className?: string;
  style?: CSSProperties;
};

function toCssDimension(value?: CSSDimension): string | undefined {
  if (typeof value === "number") {
    return `${value}px`;
  }

  return value;
}

export default function Skeleton({
  width = "100%",
  height = 16,
  borderRadius = 8,
  inline = false,
  tone = "theme",
  className = "",
  style,
}: SkeletonProps): JSX.Element {
  const skeletonStyle: CSSProperties = {
    width: toCssDimension(width),
    height: toCssDimension(height),
    "--domino-skeleton-radius": toCssDimension(borderRadius),
    ...style,
  } as CSSProperties;

  const classes = [
    "domino-skeleton",
    inline ? "domino-skeleton--inline" : "",
    `domino-skeleton--tone-${tone}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <span aria-hidden="true" className={classes} style={skeletonStyle} />;
}
